(() => {
  'use strict';

  if (customElements.get('video-background')) return;

  class VideoBackground extends HTMLElement {
    connectedCallback() {
      this.videoId = this.querySelector('[data-video-id]');
      this.videoPlayer = this.querySelector('[data-video-player]');
      this.videoTemplate = this.querySelector('[data-video-template]');
      this.videoPlayButton = this.querySelector('[data-video-bg-play]') || this.closest('[data-video-slide]')?.nextElementSibling?.querySelector('[data-video-bg-play]');
      this.handlePlayRequest = (event) => {
        event.preventDefault();
        this.video?.play();
      };
      this.videoPlayButton?.addEventListener('click', this.handlePlayRequest);

      if (!this.videoId || !this.videoPlayer || !this.videoTemplate) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection?.saveData === true;
      if (reducedMotion || saveData) {
        this.classList.add('is-paused');
        return;
      }

      this.scheduleVideo();
    }

    scheduleVideo() {
      const observe = () => {
        const start = () => this.observeVideo();
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(start, {timeout: 2000});
        } else {
          window.setTimeout(start, 300);
        }
      };

      if (document.readyState === 'complete') {
        observe();
      } else {
        window.addEventListener('load', observe, {once: true});
      }
    }

    observeVideo() {
      if (!this.isConnected || this.videoObserver) return;

      this.videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.hydrateVideo();
          observer.unobserve(entry.target);
        });
      }, {root: null, rootMargin: '150px', threshold: 0.1});

      this.videoObserver.observe(this.videoPlayer);
    }

    hydrateVideo() {
      if (this.video) return;

      this.classList.add('is-paused');
      this.videoPlayer.append(this.videoTemplate.content.cloneNode(true));
      this.video = this.querySelector('[data-video-autoplay]');
      this.videoPlayer.classList.remove('is-loading');

      if (!this.video) return;

      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => this.videoPlayButton?.classList.add('hidden'))
          .catch(() => this.videoPlayButton?.classList.remove('hidden'));
      }

      this.video.addEventListener('play', () => {
        this.classList.remove('is-paused');
        this.videoPlayButton?.classList.add('hidden');
      });
    }

    disconnectedCallback() {
      this.videoObserver?.disconnect();
      this.videoPlayButton?.removeEventListener('click', this.handlePlayRequest);
    }
  }

  customElements.define('video-background', VideoBackground);
})();
